import produce from "immer"
import { ASC } from "const"
import {
    MarkovRedistributionStateFrom,
    MarkovRedistributionStateTo,
} from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovRedistributionStateFrom: MarkovRedistributionStateFrom = {
    redistributionId: null,
    stateId: null,
    expression: "",
}

export const initMarkovRedistributionStateTo: MarkovRedistributionStateTo = {
    redistributionId: null,
    stateId: null,
    expression: "",
}

const initMarkovRedistributionStateState: types. MarkovRedistributionStateState = {
    from: {
        stateList: {},
        stateIds: [],
        stateEdit: initMarkovRedistributionStateFrom,

        calculatedExpressions: {},

        sortColumn: "order",
        sortOrder: ASC,
        filters: {},

        reloadList: true,
        reloadEdit: true,
    },
    to: {
        stateList: {},
        stateIds: [],
        stateEdit: initMarkovRedistributionStateTo,

        calculatedExpressions: {},

        sortColumn: "order",
        sortOrder: ASC,
        filters: {},

        reloadList: true,
        reloadEdit: true,
    },
}

const markovRedistributionStateReducer = produce((
    draft: types.MarkovRedistributionStateState = initMarkovRedistributionStateState,
    action: ActionTypes = null,
): types.MarkovRedistributionStateState => {
    switch (action.type) {
        // state from

        case types.MARKOV_REDISTRIBUTION_STATE_FROM_LIST:
            draft.from.stateList = action.stateList
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_FROM_IDS:
            draft.from.stateIds = action.stateIds
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_FROM_EDIT:
            draft.from.stateEdit = action.state
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_FROM_CALCULATED_EXPRESSIONS:
            draft.from.calculatedExpressions = action.calcualted
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_FROM_SORT:
            draft.from.sortColumn = action.sortColumn
            draft.from.sortOrder = action.sortOrder
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_FROM_FILTERS:
            draft.from.filters = action.filters
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_FROM_RELOAD_LIST:
            draft.from.reloadList = action.value
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_FROM_RELOAD_EDIT:
            draft.from.reloadEdit = action.value
            return draft

            // state to

        case types.MARKOV_REDISTRIBUTION_STATE_TO_LIST:
            draft.to.stateList = action.stateList
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_TO_IDS:
            draft.to.stateIds = action.stateIds
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_TO_EDIT:
            draft.to.stateEdit = action.state
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_TO_CALCULATED_EXPRESSIONS:
            draft.to.calculatedExpressions = action.calcualted
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_TO_SORT:
            draft.to.sortColumn = action.sortColumn
            draft.to.sortOrder = action.sortOrder
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_TO_FILTERS:
            draft.to.filters = action.filters
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_TO_RELOAD_LIST:
            draft.to.reloadList = action.value
            return draft

        case types.MARKOV_REDISTRIBUTION_STATE_TO_RELOAD_EDIT:
            draft.to.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovRedistributionStateReducer
